import React from "react";
import { Check } from "lucide-react";

export const POSITIONS = ["Portero", "Defensa central", "Lateral", "Mediocentro", "Interior o mediapunta", "Extremo", "Delantero", "Otra posición"];
export const GOALS = [
  "Mejorar velocidad y explosividad", "Ganar fuerza y rendir mejor en duelos",
  "Mejorar resistencia y rendimiento en partidos", "Conseguir más minutos y luchar por la titularidad",
  "Prepararme para pruebas o entrar en un nuevo club", "Mejorar mi rendimiento general", "Otro objetivo",
];
export const BUDGETS = [
  ["lt_50", "Menos de 50 €/mes"], ["50_99", "Entre 50 y 99 €/mes"], ["100_149", "Entre 100 y 149 €/mes"],
  ["150_199", "Entre 150 y 199 €/mes"], ["gte_200", "200 €/mes o más"], ["unsure", "Todavía no tengo claro el presupuesto"],
];
export const START_WHEN = [
  ["asap", "Lo antes posible"], ["next_month", "En el próximo mes"], ["later", "Más adelante"], ["unsure", "Aún no lo sé"],
];
export const PREFIXES = [
  ["+34", "ES +34"], ["+351", "PT +351"], ["+33", "FR +33"], ["+39", "IT +39"], ["+44", "UK +44"], ["+49", "DE +49"],
  ["+41", "CH +41"], ["+32", "BE +32"], ["+31", "NL +31"], ["+40", "RO +40"], ["+212", "MA +212"], ["+1", "US +1"],
  ["+52", "MX +52"], ["+54", "AR +54"], ["+57", "CO +57"], ["+58", "VE +58"], ["+51", "PE +51"], ["+56", "CL +56"],
  ["+593", "EC +593"], ["+598", "UY +598"], ["+595", "PY +595"], ["+591", "BO +591"], ["+53", "CU +53"], ["+1809", "DO +1809"],
];
export const AGES = Array.from({ length: 40 }, (_, i) => i + 6);

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export const Option = ({ on, onClick, label, multi, testid }) => (
  <button type="button" className={`emp-opt${on ? " on" : ""}`} onClick={onClick} data-testid={testid} aria-pressed={on}>
    <span className={`emp-tick${multi ? "" : " round"}`}>{on && <Check size={14} strokeWidth={3} />}</span>
    <span>{label}</span>
  </button>
);

export const ChoiceList = ({ options, value, onChange, multi, prefix }) => (
  <div className="emp-opts">
    {options.map((o) => {
      const [key, label] = Array.isArray(o) ? o : [o, o];
      const on = multi ? value.includes(key) : value === key;
      const toggle = () => onChange(multi ? (on ? value.filter((v) => v !== key) : [...value, key]) : key);
      return <Option key={key} on={on} onClick={toggle} label={label} multi={multi} testid={`${prefix}-${slug(key)}`} />;
    })}
  </div>
);

export const TextArea = ({ value, onChange, max, placeholder, testid, rows }) => (
  <div className="emp-field">
    <textarea className="emp-textarea" value={value} maxLength={max} rows={rows} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)} data-testid={testid} />
    <div className={`emp-counter${value.length >= max ? " warn" : ""}`} data-testid={`${testid}-counter`}>{value.length}/{max}</div>
  </div>
);

export const TextInput = ({ label, value, onChange, testid, ...rest }) => (
  <div className="emp-field">
    <label>{label}</label>
    <input className="emp-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />
  </div>
);
